import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import {
  alarmResponseStaleMinutes,
  formatDateTimeStamp,
  isLargeScreen,
  isLargeScreenFun,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { QueuedEventsComponent } from '../../../shared/components/queued-events/queued-events.component';
import { ScanCheckpointComponent } from '../../../shared/components/scan-checkpoint/scan-checkpoint.component';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { gTDB } from '../../../shared/services/db';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../../shared/services/orientationlock.service';
import { ToasterService } from '../../../shared/services/toaster.service';

import { IncidentsService } from '../incidents/incidents.service';
import { JobsService } from '../jobs/jobs.service';
import { PagesService } from '../pages.service';
import { UsersService } from '../users/users.service';

import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { RequestLeaveComponent } from '../../../shared/components/request-leave/request-leave.component';
import { HolAndMessageService } from '../hol-and-message/hol-and-message.service';

@Component({
  selector: 'gtapp-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: false,
})
export class HomeComponent implements OnInit, AfterViewInit {
  updateTask: any = 'updateJob';
  updateEvenDetails: any = {};

  staleMinutes: any = alarmResponseStaleMinutes;

  subscriberStats: any;
  dashBoardData: any = {};
  credStatData: any = {};
  jobStats: any;

  isDispatchUser: any;
  isAdmin: any;
  isSubscriberAdmin: boolean = false;
  isSubscriptionActive: boolean = false;

  offlineMode: boolean = !navigator.onLine;
  offlineData: any;
  queuedResposeListData: any = [];

  isSuperUser: boolean = false;
  dialogRef: any;

  bottomSectionFixedHeight: string = '180px';
  isPageLoad: boolean = false;

  largeView = isLargeScreen;
  isLargeScreenSubscription: Subscription = new Subscription();
  deviceInfoSubscription: Subscription = new Subscription();

  userPromptListData: any = [];

  //missed welfare check data variables
  totalRowsMissedWelfareCheck: number = 0;
  previousMissedWelfareCheck: number = 0;
  pageSizeMissedWelfareCheck: number = 10;
  pageNumMissedWelfareCheck: number = 1;
  totalPagesMissedWelfareCheck: number = 0;
  searchParamsMissedWelfareCheck: any;
  sortKeysMissedWelfareCheck: any = ['-missed_at'];
  dateRangeMissedWelfareCheck: any;
  dateRangeValueMissedWelfareCheck: any;

  otherParamsMissedWelfareCheck: any;
  missedWelfareData: any;

  draftedHOLExists: boolean = false;
  holReceivedExists: boolean = false;

  groupUserCount = this.pageService.getGroupUserCount();

  // to temp hide the btn in case user missed it and provides a reason on the pages component
  hideMissedWelfareCheckInBtn = false;

  showGettingStartedGuide: boolean = false;

  incidentsDataList: any = [];
  moreActiveIncidentsAvailable: boolean = false;
  incidentTableDetailData: any = [
    {
      name: 'incident_type',
      tableColumnStyle: {
        'white-space': 'pre-line',
      },

      suffixNestedValue: (row: any) => {
        return `\n ${row?.site_name} [${row?.company_name}]\n ${formatDateTimeStamp(row?.created_at, 'd MMM y HH:mm', 'en_US')}`;
      },
      suffixStyle: {
        'font-size': '0.85rem',
      },
    },
    {
      tableColumnStyle: {
        'white-space': 'pre-line',
        'text-align': 'end',
        'vertical-align': 'top',
      },

      suffixNestedValue: (row: any) => {
        return row?.status == 0
          ? row?.submitted_at
            ? 'Report Not Sent' // Resolved, not sent
            : 'In Progress' // Open not yet resolved
          : 'Completed'; // Sent
      },
      conditionalSuffixStyle: (row: any) => {
        if (row?.status === 0) {
          // Resolved - report not sent out
          if (row?.submitted_at) {
            return {
              'background-color': 'var(--bs-white)',
              'color': 'var(--bs-success)',
              'border': '1px solid',
              'border-radius': '5px',
              'padding': '0 0.5rem',
              'float': 'right',
              'font-size': 'small',
              'font-weight': '600',
              'text-align': 'center',
            };
          } else {
            // 'In Progress' Open not yet resolved
            return {
              'background-color': 'var(--bs-white)',
              'color': 'var(--bs-primary)',
              'border': '1px solid',
              'border-radius': '5px',
              'padding': '0 0.5rem',
              'float': 'right',
              'font-size': 'small',
              'font-weight': '600',
              'text-align': 'center',
            };
          }
        } else {
          // Completed and report sent
          return {
            'background-color': 'var(--bs-success)',
            'color': 'var(--bs-white)',
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'float': 'right',
            'font-size': 'small',
            'font-weight': '600',
            'text-align': 'center',
          };
        }
      },
    },
  ];
  staleUpdateLogReqTimeOutFn: any;

  isSOSButtonPressed: boolean = false;
  startX = 0;
  translateX = 0;
  maxSlide = 0;

  pinnedMessages: any = [];
  readPinnedMessages: any = [];
  showPinnedMessagesComponent: boolean = true;

  clientDbItemCheckMethodTimeOut: any;

  constructor(
    private appService: AppService,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private dataCheckService: DataCheckService,
    private jobService: JobsService,
    private ngZone: NgZone,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private profileService: UserProfileService,
    private userService: UsersService,
    private deviceInfoService: DeviceInfoService,
    private orientationService: OrientationLockService,
    private handOverLogService: HolAndMessageService,
    private pageService: PagesService,
    private incidentService: IncidentsService,
  ) {
    const userData = this.appService.getUserData();

    this.isSuperUser = this.dataCheckService.isSuperUser();

    if (!userData?.access) {
      this.router.navigate(['/login']);
    }
    if (this.isSuperUser === true) {
      this.router.navigate(['/gtadmin/dashboard']);
      return;
    }
    if (this.dataCheckService.isPrimeContractorUser()) {
      this.router.navigate(['pc']);
      return;
    }
    this.isDispatchUser = this.dataCheckService.isDispatchUser();
    this.isAdmin = this.dataCheckService.isUserAdmin();

    this.isSubscriberAdmin = this.dataCheckService.isSubscriberAdmin();
    this.isSubscriptionActive =
      this.dataCheckService.checkIsSubscriptionOrTestUser();
  }
  startSwipe(event: PointerEvent) {
    const slider = document.getElementById('sos-slider');

    if (!slider) return;

    slider.setPointerCapture(event.pointerId);

    const sliderTrack: any = slider.querySelector('.slider-track');

    const width = slider?.offsetWidth;

    if (sliderTrack?.offsetWidth) {
      this.maxSlide = Math.min(sliderTrack.offsetWidth, width) - 60; // - btn width/height;
    } else {
      this.maxSlide = width - 60; // - btn width/height;
    }

    this.startX = event.clientX;
  }

  moveSlider(event: PointerEvent, confirmSOSTemplate: any) {
    if (!this.isSOSButtonPressed) return;

    if (this.maxSlide < 50) return;
    // https://app.shortcut.com/sendem/story/10819/add-vibration-to-certain-actions-to-improve-ux

    this.deviceInfoService.triggerCustomPulsePattern([20, 50, 20]);

    const dx = this.startX - event.clientX;

    this.translateX = -Math.min(Math.max(dx, 0), this.maxSlide);

    if (Math.abs(this.translateX) >= this.maxSlide * 0.99) {
      const slider = document.getElementById('sos-slider');

      slider?.releasePointerCapture(event.pointerId);

      this.triggerSOS(confirmSOSTemplate);
    }
  }
  triggerSOS(confirmSOSTemplate: any) {
    this.isSOSButtonPressed = false;

    this.translateX = 0;
    this.callSOSApi(confirmSOSTemplate);
  }

  endSwipe(event: PointerEvent, confirmSOSTemplate: any) {
    if (!this.isSOSButtonPressed) return;
    if (this.maxSlide < 50) return;

    const slider = document.getElementById('sos-slider');

    slider?.releasePointerCapture(event.pointerId);

    this.isSOSButtonPressed = false;

    if (Math.abs(this.translateX) >= this.maxSlide * 0.96) {
      this.triggerSOS(confirmSOSTemplate);
    } else {
      this.translateX = 0;
    }
  }

  async ngAfterViewInit(): Promise<void> {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.cdr.detectChanges();
        this.spinnerService.hide();
      });
    }, 100);

    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
        }
      });
  }

  ngOnDestroy() {
    this.isLargeScreenSubscription?.unsubscribe();
    this.deviceInfoSubscription?.unsubscribe();
  }
  ngOnInit() {
    this.spinnerService.show();
    const manageSubscriptionRoutedLink: boolean =
      sessionStorage.getItem(btoa('manageSubscriptionRoutedLink')) == 'true';

    sessionStorage.removeItem(btoa('manageSubscriptionRoutedLink'));
    if (
      (this.isSubscriberAdmin && !this.isSubscriptionActive) ||
      manageSubscriptionRoutedLink
    ) {
      const state = manageSubscriptionRoutedLink
        ? {}
        : { state: 'Account Verified! Subscription Required' };
      this.router.navigate(['/subscription', state]);
    } else {
      this.deviceInfoSubscription =
        this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
          if ('appStatus' in value) {
            this.offlineDataCheck(true);
            this.offlineMode = !value?.appStatus;
          }
          if ('syncItemsInDb' in value) {
            this.getItemsInClientDBAndUpdateWithTimeOut();
          }
          if ('syncComplete' in value) {
            this.getItemsInClientDBAndUpdateWithTimeOut();
          }

          if ('restartGetStarted' in value) {
            this.formatDashBoardData(this.dashBoardData);
          }
          if ('wsn_user_prompt_updates' in value) {
            this.getHomeScreenPrompts();
          }
          if (value?.checkMissedWelfareCheckInBtn) {
            this.hideMissedWelfareCheckInBtn = true;

            setTimeout(() => {
              this.hideMissedWelfareCheckInBtn = false;
              this.getHomePageData();
            }, 10000);
          }
        });

      if (!this.isSuperUser) {
        this.getSubsciberUserId();
        this.getHomePageData();
        this.getHomeScreenPrompts();
        setTimeout(() => {
          this.checkForDrafts();
        }, 10000);
      }
      this.offlineDataCheck(true);

      this.spinnerService.hide();
    }

    this.ngZone.run(() => {
      setTimeout(() => {
        this.isPageLoad = true;
        this.calculateFixedBottomHeight();
      }, 300);
    });
    if (
      this.updateTask === 'updateJob' &&
      sessionStorage.getItem('updateAvailable') === 'true'
    ) {
      this.toasterService.setMessage({
        successMessage: 'Please Wait, Updating Guard Tracker',
        errorMessage: '',
      });
      //making sure that the user is in home page and is doing nothing, to do a reload to clear the cache
      sessionStorage.removeItem('updateAvailable');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
    if (this.isAdmin || this.isDispatchUser) {
      this.getActiveIncidents();
    }
    if (this.isAdmin) this.getCredentialStatData();

    // if (!this.largeView && (this.isAdmin || this.isDispatchUser)) {
    //   let reqBody: any = { event_type: 'user_live_jobs' };
    //   this.userService
    //     .getUserUpdateLog(reqBody, { exists_check: 1 })
    //     .subscribe((response: any) => {
    //       this.operationsOverViewPresent = response?.data || false;
    //     });
    // }
  }
  async getIndexDbData(path: string) {
    try {
      const result: any = await gTDB.cachedData
        .where('shortPath')
        .equals(path)
        .first();

      return result;
    } catch (error) {
      return {};
    }
  }
  async getItemsInClientDBAndUpdate() {
    // the index db will hold only queued items and failed items. successull api call will delete the items from index db, no point in keeping it there.
    // we will split the items into failed and queues based on the apiResponse dict which sort of acts like FK, as there is an issue, where the object containing images is updated,
    // the image becomes corrupted, so going for a FK to check whether the api has failed and recording it.the failed data is also deleted after 24 hours.
    // This is done so that images are very large in size these days and keeping it in phone for days is not good.
    // The guard can also see the failed items and can choose to retry sending the failed one or deleting it from the home page.
    // Added a logic where the service worker will call the api once more after 5 second when it is failed at the first time.

    // This list will also contain the items stored in the sql db of native app

    let existingIdSet = new Set();
    let staleErrorItems = [];
    [this.queuedResposeListData, existingIdSet] =
      await this.pageService.getSavedItemsInClientDb();

    const apiResponseDict = (await gTDB.userData.get('apiResponseDict')) || {};

    const filterDate = Date.now() - 24 * 60 * 60 * 1000;

    for (const key in apiResponseDict) {
      const value = apiResponseDict[key];

      const apiTime = value?.apiSyncTime
        ? new Date(value.apiSyncTime).getTime()
        : 0;

      if (apiTime < filterDate) {
        staleErrorItems.push(key);
      }
    }

    // Remove items not in existingIds
    for (const key of Object.keys(apiResponseDict)) {
      if (!existingIdSet?.has(key) || staleErrorItems?.includes(key)) {
        delete apiResponseDict[key];
      }
    }

    if (staleErrorItems?.length > 0) {
      this.deleteCachedData(staleErrorItems);
    }

    await gTDB.userData.put(apiResponseDict, 'apiResponseDict');

    return true;
  }
  getItemsInClientDBAndUpdateWithTimeOut() {
    if (this.clientDbItemCheckMethodTimeOut)
      clearTimeout(this.clientDbItemCheckMethodTimeOut);

    this.clientDbItemCheckMethodTimeOut = setTimeout(async () => {
      await this.getItemsInClientDBAndUpdate();
      if (this.queuedResposeListData?.length && !this.offlineMode) {
        this.pageService.miscSubjectParam.next({ syncData: true });
      }
    }, 500);
  }

  async offlineDataCheck(bypass = false) {
    this.getItemsInClientDBAndUpdateWithTimeOut();

    if (this.offlineMode || bypass) {
      const offlineDataDict = {
        checkpointData: await this.getIndexDbData(
          '/api/check_point/list_nearest/',
        ),
        siteData: await this.getIndexDbData('/api/site/list_nearest/'),
      };
      this.offlineData = offlineDataDict;
    }
    const deletedQueuedItemList = JSON.parse(
      localStorage.getItem(btoa('deletedQueuedItemList')) || '[]',
    );

    const scanTimerLogList: any = JSON.parse(
      localStorage.getItem(btoa('scanTimerLogs')) || '[]',
    );

    if (
      (this.queuedResposeListData?.length ||
        deletedQueuedItemList?.length ||
        scanTimerLogList?.length) &&
      !this.offlineMode
    ) {
      clearTimeout(this.staleUpdateLogReqTimeOutFn);
      this.staleUpdateLogReqTimeOutFn = setTimeout(() => {
        try {
          if (this.queuedResposeListData?.length)
            this.updateStaleEventsInQueue();
          if (deletedQueuedItemList?.length) {
            this.profileService
              .logQueuedStaleUpdates(
                { data: deletedQueuedItemList },
                { log_deleted: 1 },
                false,
              )
              .then((res: any) => {});

            localStorage.removeItem(btoa('deletedQueuedItemList'));
          }
          if (scanTimerLogList?.length) {
            this.profileService
              .logQueuedStaleUpdates(
                { data: scanTimerLogList },
                { scan_time_logs: 1 },
                false,
              )
              .then((res: any) => {});

            localStorage.removeItem(btoa('scanTimerLogs'));
          }
        } catch (error) {}
      }, 500);
    }
    this.ngZone.run(() => {
      setTimeout(() => {
        this.isPageLoad = true;
        this.calculateFixedBottomHeight();
      }, 300);
    });
  }

  closeDetailedHome() {
    if (
      [
        'scanCheckPoint',
        'addSiteComment',
        'addSitePhoto',
        'userPromptInfo',
      ].includes(this.updateTask)
    ) {
      this.updateTask = 'updateJob';
    }
    this.offlineDataCheck();

    if (!this.isSuperUser) this.getSubsciberUserId();

    setTimeout(() => {
      this.checkForDrafts();
    }, 2500);
  }
  checkForDrafts() {
    const tempValue: any = sessionStorage.getItem('handOverLogUpdate');
    if (tempValue > 0) {
      if (!this.draftedHOLExists || !this.holReceivedExists) {
        this.checkForHOL();
      }
      sessionStorage.removeItem('handOverLogUpdate');
    }
  }

  getHomePageData() {
    this.spinnerService.show();
    this.getPinnedMessages();
    let param: any = { time_offset: new Date().getTimezoneOffset() };
    if (this.staleMinutes) {
      param.stale_minutes = this.staleMinutes;
    }

    this.jobService.getDashBoardData(param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.dashBoardData = response['data'];

        this.formatDashBoardData(this.dashBoardData);
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  checkForHOL() {
    this.handOverLogService
      .getHandOverLogs({}, { drafted_count: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.draftedHOLExists = response?.data?.drafted_hol_exists;
          this.holReceivedExists =
            response?.data?.hand_over_log_received_exists;
          this.handOverLogService.updateHOLDraftCount(
            this.draftedHOLExists ? 1 : 0,
          );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  checkGettingStartedGuide() {
    setTimeout(() => {
      const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');

      if (!Object.keys(userGuide)?.length) {
        this.checkGettingStartedGuide();
      } else {
        this.showGettingStartedGuide =
          !userGuide?.hideGetStarted && this.isAdmin;

        if (this.showGettingStartedGuide) {
          this.pageService.miscSubjectParam.next({
            showGettingStartedGuide: true,
          });
        }
      }
    }, 500);
  }

  formatDashBoardData(data: any) {
    //As route feat is not added at the moment no need to call this api.
    // this.getPendingCheckPoints();

    this.subscriberStats = data?.subscriber_stats;
    this.draftedHOLExists = data?.drafted_hol_exists;
    this.holReceivedExists = data?.hand_over_log_received_exists;
    this.handOverLogService.updateHOLDraftCount(
      data?.drafted_hol_exists ? 1 : 0,
    );
    this.checkGettingStartedGuide();
    localStorage.setItem(
      'subscriberStats',
      JSON.stringify(data?.subscriber_stats || {}),
    );
    this.jobStats = data?.job_stats;

    this.isPageLoad = true;
    this.spinnerService.hide();
  }

  redirectToPage(string: any) {
    if (string == 'eventLog') {
      this.router.navigate(['/user-events']);
    } else if (string == 'myJobs') {
      this.router.navigate(['/jobs'], {
        fragment: 'jobs',
      });
    } else if (string == 'unassignedJobs') {
      this.router.navigate(['/jobs'], {
        fragment: 'unassignedJobs',
      });
    } else if (string == 'unAssignedJobs') {
      this.router.navigate(['/roster-jobs'], { fragment: 'unAssignedJobs' });
    } else if (string == 'pendingShifts') {
      this.router.navigate(['/roster-jobs'], { fragment: 'pendingShifts' });
    } else if (string == 'staleShifts') {
      this.router.navigate(['/roster-jobs'], { fragment: 'staleShifts' });
    } else if (string == 'staleJobs') {
      this.router.navigate(['/jobs'], {
        fragment: 'staleJobs',
      });
    } else if (string == 'validateQr') {
      this.router.navigate(['/checkpoints'], {
        fragment: btoa(JSON.stringify({ validateQR: true })),
      });
    } else if (string == 'incidents') {
      if (
        this.dashBoardData?.open_incidents_exists ||
        this.incidentsDataList?.length
      ) {
        this.router.navigate(['/incidents'], {});
      } else {
        this.router.navigate(['/add-incident']);
      }
    } else if (string == 'handOverLog') {
      this.router.navigate(['/hand-over-log'], {});
    } else if (string == 'addHandOverLog') {
      this.router.navigate(['/add-hand-over-log'], {});
    } else if (string == 'requireAcceptance') {
      this.router.navigate(['/roster-jobs'], { fragment: 'requireAcceptance' });
    } else if (string == '3monthCred') {
      this.router.navigate(['/credentials'], { fragment: '3month' });
    } else if (string == 'expiredCred') {
      this.router.navigate(['/credentials'], { fragment: 'expired' });
    } else if (string == 'activeCred') {
      this.router.navigate(['/credentials'], { fragment: 'active' });
    } else if (string == 'activeIncidents') {
      this.router.navigate(['/incidents'], {
        fragment: btoa(
          JSON.stringify({
            selectedFilter: 'default',
          }),
        ),
      });
    } else if (string == 'operations') {
      this.router.navigate(['/operations-overview']);
    } else if (string == 'pinnedMessages') {
      this.router.navigate(['/hand-over-log'], {
        fragment: btoa(
          JSON.stringify({
            selectedTab: 'Pinned Messages',
          }),
        ),
        queryParams: {},
      });
    }
  }

  openQueuedTemplate() {
    const dialogRef = this.dialogService.open(QueuedEventsComponent, {
      data: { queuedResposeListData: this.queuedResposeListData },
    });
    dialogRef
      .afterClosed()
      .subscribe((res: any) => this.getItemsInClientDBAndUpdateWithTimeOut());
  }

  calculateFixedBottomHeight() {
    // Get the bottom-section-fixed element by ID
    const bottomSectionFixed = document.getElementById('fixedBtn');
    if (bottomSectionFixed) {
      this.bottomSectionFixedHeight =
        bottomSectionFixed.offsetHeight.toString() === '0'
          ? '180' + 'px'
          : bottomSectionFixed.offsetHeight.toString() + 'px';
      this.cdr.detectChanges();
    }
  }

  getHomeScreenPrompts() {
    this.jobService.getHomeUserPromptList().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.userPromptListData = response?.data;
      }
    });
  }

  callSOSApi(alertSOSTemplateRef: TemplateRef<any>) {
    this.spinnerService.show();
    this.profileService
      .updateUser({}, { send_sos: 1 })
      .then((response: any) => {
        if (response?.status == 'success') {
          this.spinnerService.hide();
          this.dialogRef = this.dialogService.open(
            alertSOSTemplateRef,
            {
              data: {},
            },
            this.viewContainerRef,
          );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
          this.spinnerService.hide();
        }
      });
  }

  openMissedWelfareCheckInEvents(template?: TemplateRef<any>) {
    this.spinnerService.show();

    let body: any = {
      event_type: 'missed_welfare_checks',
      missed: 1,
    };
    if (this.dateRangeMissedWelfareCheck && window.innerWidth < 770)
      body.date_range = this.dateRangeMissedWelfareCheck;

    if (this.sortKeysMissedWelfareCheck)
      body.sort_key = this.sortKeysMissedWelfareCheck;

    if (this.searchParamsMissedWelfareCheck)
      body.search_filters = this.searchParamsMissedWelfareCheck;

    if (this.pageSizeMissedWelfareCheck) {
      body['rows'] = this.pageSizeMissedWelfareCheck;
    }
    if (this.previousMissedWelfareCheck) {
      body['previous'] = this.previousMissedWelfareCheck;
    }

    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.missedWelfareData = response['data'];

        if (this.missedWelfareData?.length) {
          if (template)
            this.dialogRef = this.dialogService.open(
              template,
              {
                data: {},
              },
              this.viewContainerRef,
            );
        } else {
          this.dashBoardData.missed_welfare_checks = false;
        }

        this.spinnerService.hide();
        this.totalRowsMissedWelfareCheck = response['total_size'];
        this.dashBoardData.missed_welfare_checks = Boolean(
          this.totalRowsMissedWelfareCheck,
        );

        this.totalPagesMissedWelfareCheck = Math.ceil(
          this.totalRowsMissedWelfareCheck / this.pageSizeMissedWelfareCheck,
        );
        this.otherParamsMissedWelfareCheck = {
          paginationData: {
            tableTotalRows: this.totalRowsMissedWelfareCheck,
            tablePreviousRows: this.previousMissedWelfareCheck,
            tableRows: this.pageSizeMissedWelfareCheck,
            tablePageNum: this.pageNumMissedWelfareCheck,
            tableTotalPages: this.totalPagesMissedWelfareCheck,
          },
        };
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  updateMissedReason(missedEventData: any) {
    this.jobService
      .updateMissedEvent({
        event_id: missedEventData?.id,
        missed_reason: missedEventData?.missedReason,
      })
      .then((response: any) => {
        if (response?.status === 'success') {
          this.openMissedWelfareCheckInEvents();
        }
      });
  }

  async deleteCachedData(keys: any) {
    const intKeys = keys
      .map((key: any) => parseInt(key, 10))
      .filter((num: any) => !isNaN(num));
    await gTDB.gtSavedData.bulkDelete(intKeys);
  }

  async getSubsciberUserId() {
    const userData = this.appService.getUserData();

    const subUserId = userData?.subscriber?.subscriber_user_id;
    if (!subUserId) {
      this.pageService
        .refreshTokenApi(this.isSuperUser ? 1 : 0)
        .subscribe((resp: any) => {
          if (resp?.subscriber?.subscriber_user_id) {
            const userData = this.appService.getUserData();
            userData.subscriber = resp?.subscriber;
            this.appService.setUserData(userData);
          }
        });
    }
  }

  showGuideOptions(guideItem: string) {
    if (guideItem === 'hideGetStarted') {
      this.showGettingStartedGuide = false;
    }
    this.pageService.miscSubjectParam.next({ startGuide: guideItem });
  }
  getCredentialStatData() {
    this.spinnerService.show();
    let param: any = {
      time_offset: new Date().getTimezoneOffset(),
      credential_stats: 1,
    };

    this.jobService.getDashBoardData(param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.credStatData = response?.data;
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }

  async openScanCPTemplate() {
    const dialogRef = this.dialogService.open(
      ScanCheckpointComponent,
      {
        data: {
          showNormalScanBtn: this.offlineMode
            ? this.offlineData?.checkpointData?.data?.length
            : this.subscriberStats?.checkpoint_count != 0,
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef?.afterClosed());

    if (res?.source == 'scanCheckPoint') {
      this.updateTask = 'scanCheckPoint';
    } else if (res?.source == 'scanQrCode') {
      this.offlineDataCheck();
      if (res?.data) this.getHomePageData();
    } else if (res?.source == 'scanNFCCode') {
      this.offlineDataCheck();
      if (res?.data) this.getHomePageData();
    }
  }
  getActiveIncidents() {
    let params: any = { selected_filter: 'default', rows: 3 };
    const sevenDay = new Date();
    sevenDay.setDate(sevenDay.getDate() - 7);
    let body: any = { ui_filters: { created_at__gte: sevenDay } };

    this.incidentService
      .getIncidents(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.incidentsDataList = response?.data?.slice(0, 3);

          this.moreActiveIncidentsAvailable = response?.data?.length > 3;

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onSelectIncident(event: any) {
    this.spinnerService.show();

    if (
      ((event?.status === 0 && event?.submitted_at) || event?.status === 1) &&
      (this.isAdmin || this.isDispatchUser)
    ) {
      this.router.navigate(['/review-incident', { inKey: String(event?.id) }]);
    } else {
      this.router.navigate(['/view-incident', { inKey: String(event?.id) }]);
    }
  }
  updateStaleEventsInQueue() {
    function getEventInfo(eventData: any) {
      let scanOnly = false;
      let qr_text: any;
      try {
        const formData = JSON.parse(eventData?.form_data || '{}');
        scanOnly = formData?.scanOnly || false;
        qr_text = formData?.qr_text || '';
      } catch (error) {}

      return {
        company_id: eventData?.company_id,
        job_id: eventData?.job_id,
        path_name: eventData?.pathName,
        site_id: eventData?.site_id,
        file_size: eventData?.file?.size,
        check_point_id: eventData?.check_point_id,
        qr_text: qr_text,
        scanOnly: scanOnly,
      };
    }
    let staleItems = this.queuedResposeListData?.filter(
      (item: any) =>
        new Date(item?.updated_at * 1000).getTime() <
        new Date().getTime() - 1 * 60 * 1000,
    );

    if (staleItems?.length) {
      const alreadyLogged = JSON.parse(
        localStorage.getItem(btoa('alreadyLoggedStaleQueuedUpdates')) || '[]',
      );
      staleItems = staleItems?.filter(
        (item: any) => !alreadyLogged?.includes(item?.indexDBId),
      );
      if (staleItems?.length) {
        localStorage.setItem(
          btoa('alreadyLoggedStaleQueuedUpdates'),
          JSON.stringify([
            ...new Set([
              ...alreadyLogged,
              ...staleItems?.map((item: any) => item?.indexDBId),
            ]),
          ]),
        );
        const reqData = staleItems?.map((item: any) => ({
          index_db_id: item?.indexDBId,
          recorded_at: item?.updated_at,
          additional_info: {
            device_info: item?.device_info,
            event_info: getEventInfo(item),
          },
        }));
        this.profileService
          .logQueuedStaleUpdates({ data: reqData }, {}, false)
          .then((res: any) => {});
      }
    }
  }
  getPinnedMessages() {
    this.readPinnedMessages = JSON.parse(
      localStorage.getItem(btoa('readPinnedMessages')) || '[]',
    );
    this.handOverLogService
      .getPinnedMessages({ show_pinned_messages: 1 })
      .subscribe((res: any) => {
        this.pinnedMessages = res?.data || [];
      });
  }
  async onMinimizeMessage(message: any, template: any) {
    const dialogRef = this.dialogService.open(
      template,
      { data: message },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());

    this.readPinnedMessages.push(message?.id);
    localStorage.setItem(
      btoa('readPinnedMessages'),
      JSON.stringify(this.readPinnedMessages || []),
    );
  }
  get screenWidth(): number {
    return window.innerWidth;
  }
  openLeaveRequestDialog() {
    const dialogRef = this.dialogService.open(RequestLeaveComponent);
  }
}
